export default __webpack_public_path__ + "static/media/OpenSans.a0f9d3e4.woff";